import React from 'react';
import { View, TouchableOpacity } from 'react-native';
import { Typography, Icons } from '@hmsexp/component-library';
import get from 'lodash/get';
import CheckBoxCell from './CheckBoxCell';

const TableCellFeedBack = ({ column, isHeaderCell, sortingPayload, handleOnSortClick }) => {
  const containerStyle = {
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    width: column?.width,
    minWidth: column?.width,
    paddingHorizontal: 20,
    marginRight: 20
  };

  const SortIcon = ({ column, sortingPayload }) => {
    const { field_name, direction } = sortingPayload;
    const isCurrentColumn = field_name === column.key;

    if (isCurrentColumn && direction === 1) {
      return <Icons.ChevronUp size={'XS'} color={'primaryContentMedium'} />;
    }

    if (isCurrentColumn && direction === -1) {
      return <Icons.ChevronDown size={'XS'} color={'primaryContentMedium'} />;
    }

    return (
      <>
        <Icons.ChevronUp size={'XS'} color={'primaryContentMedium'} />
        <Icons.ChevronDown size={'XS'} color={'primaryContentMedium'} />
      </>
    );
  };

  if (column?.disable === true) return null;

  if (isHeaderCell) {
    if (column?.key === 'checkbox') {
      return (
        <View
          style={{
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            width: column?.width,
            minWidth: column?.width,
            paddingHorizontal: 6,
            marginRight: 8
          }}>
          <CheckBoxCell isHeaderCell={isHeaderCell} column={column} />
        </View>
      );
    }

    return (
      <View style={containerStyle}>
        <Typography
          variant='subtitle2'
          fontWeightType='bold'
          color='primaryContentHigh'
          textProps={{
            style: {
              flexShrink: 1,
              flexWrap: 'wrap',
              textAlign: 'left',
              width: '100%'
            }
          }}>
          {get(column, 'label', '')}
        </Typography>

        {column?.sort_enabled === true && (
          <TouchableOpacity
            onPress={() => handleOnSortClick(get(column, 'key', ''))}
            style={{ marginLeft: 4, marginRight: 8 }}>
            <SortIcon column={column} sortingPayload={sortingPayload} />
          </TouchableOpacity>
        )}
      </View>
    );
  }

  return null;
};

export default TableCellFeedBack;